/* eslint-disable max-len */
import configService from './configservice';

export class FrontendAppSettingsService  {
  static CUSTOM_DOCUMENT_SETTINGS_MARKETING_INSERTS_CUSTOMIZABLE_ENABLED = 'CustomDocumentSettings.MarketingInserts.Customizable.Enabled';
  static CUSTOM_DOCUMENT_SETTINGS_GIFT_NOTES_CUSTOMIZABLE_ENABLED = 'CustomDocumentSettings.GiftNotes.Customizable.Enabled';
  static TRACKING_PAGE_CUSTOMIZATION_ENABLED = 'Trans_EnableTrackingPageCustomization';
  static CUSTOM_DOCUMENT_SETTINGS_ENABLED = 'FulfillmentSettings.EnableCustomDocumentSettings';

  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  
  getSettings() {
    return this.httpClient.get(`${configService.FrontEndAppSettingsApiUrl}/api/getSettings`);
  }
}
